module.exports = __webpack_public_path__ + "img/组 385.48003f5c.png";